<template>
  <div class="nav-item" align="center">
    <router-link :to="{
      name: routerName,
      params: {
        clientId: $route.params.clientId
      }
    }" class="nav-link">
      <div :class="icon"></div>
      <div class="">
        <span class="nav-font-size-small">{{name}}</span>
      </div>
    </router-link>
  </div>
</template>

<script>
import constants from '../../../_consts'
import {mapGetters, mapActions} from 'vuex';

export default {
  components: {
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    routerName: {
      type: String,
      default: ''
    },
    notifyNumber: {
      type: Number,
      default: 0
    },
    eventStatus: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      class1: 'small-notify-number',
      class2: 'big-notify-number',
      class3: 'sidebar-item-new-event'
    };
  },
  computed: {
    renderClass () {
      return this.notifyNumber < 10 ? this.class1 : this.class2;
    },
    renderCssItemNewEvent () {
      if (this.name === 'New Event') {
        return this.class3;
      }
    },
    ...mapGetters({
      getClientName: 'GETTERS_GET_CLIENT_NAME'
    })
  },
  methods: {
    ...mapActions({
      btnCreateNewEventOnSideBar: 'CREATE_EVENT_FLAG'
    }),
    newEventClick () {
      this.btnCreateNewEventOnSideBar(true).then(() => {
        this.$router.replace(constants.routeDirect.userDrafts);
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import '~@/styles/variables.less';

.nav-item {
  height: 80px;
  position: relative;
  .nav-link {
    height: 80px;
    padding: 0 0 0 0 !important;
    .text-section{
      margin-top: -5px;
    }
    .nav-ellipsis {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      width: 100px;
    }
  }
  .active{
    .nav-font-size-small{
      color: @white;
    }
  }
  .text {
    margin-bottom: 12px;
  }
  .icon-dashboard {
    margin: 1.5px 1.5px;
    width: 36px;
    height: 36px;
    color: @white;
    background-color: @white;
    -webkit-mask: url('../../../../static/img/24px-event-dashboard.svg') no-repeat center;
    mask: url('../../../../static/img/24px-event-dashboard.svg') no-repeat center;
    background: url('../../../../static/img/24px-event-dashboard-white.svg');
  }
  .icon-plan {
    margin: 1.5px 1.5px;
    width: 36px;
    height: 36px;
    color: @white;
    background-color: @white;
    -webkit-mask: url('../../../../static/img/24px-connectwell-plan.svg') no-repeat center;
    mask: url('../../../../static/img/24px-connectwell-plan.svg') no-repeat center;
    background: url('../../../../static/img/24px-connectwell-plan-white.svg');
  }
  .icon-manage {
    margin: 1.5px 1.5px;
    width: 36px;
    height: 36px;
    color: @white;
    background-color: @white;
    -webkit-mask: url('../../../../static/img/24px-connectwell-manage.svg') no-repeat center;
    mask: url('../../../../static/img/24px-connectwell-manage.svg') no-repeat center;
    background: url('../../../../static/img/24px-connectwell-manage-white.svg');
  }
  .icon-report {
    margin: 1.5px 1.5px;
    width: 36px;
    height: 36px;
    color: @white;
    background-color: @white;
    -webkit-mask: url('../../../../static/img/24px-graph.svg') no-repeat center;
    mask: url('../../../../static/img/24px-graph.svg') no-repeat center;
    background: url('../../../../static/img/24px-graph-white.svg');
  }
}

.fa-stack[data-count]:after {
  content: attr(data-count);
  font-size: 9px;
  line-height: .75em;
  text-align: center; // font-weight: bold;
  top: 5px;
  color: @dark-blue-1;
  position: absolute;
}

.fa-stack::after {
  align-content: center;
}

.small-notify-number::after {
  left: 5px;
}

.big-notify-number::after {
  left: 3px;
}

.icon-size {
  height: 26px;
  width: 26px;
  // font-size: 26px;
  // line-height: 26px;
  margin: 0 0 0 0;
  background-color: transparent;
}

.nav-font-size-small {
  font-size: 12px;
  font-family: @font-family-main;
  line-height: 14px;
  text-align: center;
}


.sidebar .nav .nav-item .nav-link [class^="icon-"]{
  margin-top: 13px;
}

.sidebar .nav .nav-item .nav-link {
  width: 96px;
  border-left: 5px solid @dark-blue-3;
  &:hover{
    border-left: 5px solid #8BC5D6;
  }
}

.sidebar .nav .nav-item .nav-link.active{
  color: @white;
  border-left: 5px solid #8BC5D6;
  background-color: #194975;
}
.sidebar .nav .nav-item .nav-item-margin{
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// SidebarNavIcons.vue?4815b621